var _defs, _polygon, _path, _polygon2, _path2, _polygon3, _path3, _polygon4, _path4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _path5, _path6, _path7, _polygon23, _path8, _polygon24, _polygon25, _path9, _path10, _polygon26, _path11, _path12, _path13, _polygon27, _path14, _polygon28, _path15, _path16, _path17, _path18, _path19, _polygon29, _path20, _polygon30, _polygon31, _polygon32, _polygon33, _path21, _path22, _polygon34, _path23, _path24, _polygon35, _path25, _path26, _polygon36, _path27, _path28, _rect, _rect2, _rect3, _path29, _path30, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiLang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200.18 292.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#ffa98c;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#New_Gradient_Swatch_copy_25);}.cls-7{fill:url(#New_Gradient_Swatch_copy_25-2);}.cls-8{fill:url(#linear-gradient-5);}.Graphic-Style-3{fill:url(#New_Gradient_Swatch_copy_26);}.Graphic-Style-2{fill:url(#linear-gradient-6);}.cls-9{fill:url(#New_Gradient_Swatch_copy_25-3);}.cls-10{fill:url(#New_Gradient_Swatch_copy_25-4);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#New_Gradient_Swatch_copy_25-5);}.cls-13{fill:url(#New_Gradient_Swatch_copy_25-6);}.cls-14{fill:url(#linear-gradient-9);}.cls-15{fill:url(#New_Gradient_Swatch_copy_25-7);}.cls-16{fill:url(#New_Gradient_Swatch_copy_25-8);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:#2af6ff;}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:#fff;}.cls-32{fill:#266ec4;}.cls-33{fill:#db2e2e;}.cls-34{fill:#2e4593;}.cls-35{fill:#fdffff;}.cls-36{fill:#3c5ebf;}.cls-37{fill:#3ec14d;}.cls-38{fill:#28292b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 166.24,
    y1: 191.34,
    x2: 120.41,
    y2: 203.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c46aa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9033c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 159.24,
    y1: 210.34,
    x2: 113.41,
    y2: 222.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 56.7,
    y1: 185.44,
    x2: 82.7,
    y2: 202.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 56.83,
    y1: 204.19,
    x2: 82.83,
    y2: 221.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25",
    x1: 122.89,
    y1: 262.45,
    x2: 245.93,
    y2: 225.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-2",
    x1: -4.19,
    y1: 277.36,
    x2: 157.63,
    y2: 241.09,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 154.32,
    y1: 141.75,
    x2: 90.14,
    y2: 264.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26",
    x1: 465.59,
    y1: 378.76,
    x2: 580.51,
    y2: 344.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 374.48,
    y1: 384.52,
    x2: 525.62,
    y2: 350.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1fc3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-3",
    x1: 122.68,
    y1: 246.63,
    x2: 248.44,
    y2: 208.97,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-4",
    x1: -5.95,
    y1: 261.88,
    x2: 159.47,
    y2: 224.79,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 154.32,
    y1: 123.29,
    x2: 90.14,
    y2: 245.6,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-5",
    x1: 122.47,
    y1: 225.73,
    x2: 250.95,
    y2: 187.25,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-6",
    x1: -7.72,
    y1: 241.3,
    x2: 161.31,
    y2: 203.41,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 154.32,
    y1: 99.75,
    x2: 90.14,
    y2: 222.05,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-7",
    x1: 122.23,
    y1: 198.55,
    x2: 253.97,
    y2: 159.1,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-8",
    x1: -9.83,
    y1: 214.53,
    x2: 163.52,
    y2: 175.67,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 128.96,
    y1: 117.73,
    x2: 79.11,
    y2: 212.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 122.09,
    y1: 291.06,
    x2: 116.09,
    y2: 198.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 152.92,
    y1: 290.62,
    x2: 124.55,
    y2: 223.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 16.77,
    y1: 253.55,
    x2: 72.6,
    y2: 205.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 36.57,
    y1: 276.45,
    x2: 81.3,
    y2: 236.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 89.6,
    y1: 283.63,
    x2: 94.71,
    y2: 211.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 54.74,
    y1: 292.65,
    x2: 88.24,
    y2: 251.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 183.4,
    y1: 246.68,
    x2: 136.74,
    y2: 200.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 171.81,
    y1: 268.01,
    x2: 143.31,
    y2: 236.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 77.74,
    y1: 8.49,
    x2: 106.99,
    y2: 171.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 113.47,
    y1: 29.55,
    x2: 109.47,
    y2: 161.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 68.79,
    y1: 44.45,
    x2: 96.29,
    y2: 162.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 152.54,
    y1: 30.08,
    x2: 100.54,
    y2: 138.33,
    xlinkHref: "#linear-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.39 235.38 132.89 230.96 132.89 197.92 127.51 187.67 127.51 163.97 128.51 163.97 128.51 187.43 133.89 197.68 133.89 230.39 140.38 234.22 173.62 213.78 174.14 214.64 140.39 235.38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M548.22,333.06a4.51,4.51,0,0,1-4.08,0c-1.13-.65-1.14-1.71,0-2.35a4.51,4.51,0,0,1,4.08,0A1.25,1.25,0,0,1,548.22,333.06Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "133.39 254.38 125.89 249.96 125.89 216.92 120.51 206.67 120.51 182.97 121.51 182.97 121.51 206.43 126.89 216.68 126.89 249.39 133.38 253.22 166.62 232.78 167.14 233.64 133.39 254.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M541.22,352.06a4.51,4.51,0,0,1-4.08,0c-1.13-.65-1.14-1.71,0-2.35a4.51,4.51,0,0,1,4.08,0A1.25,1.25,0,0,1,541.22,352.06Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "66.18 235.68 65.92 235.52 33.87 215.71 34.4 214.86 66.18 234.51 80.68 225.81 80.68 205.2 91.68 187.45 91.68 164.01 92.68 164.01 92.68 187.74 81.68 205.49 81.68 226.38 66.18 235.68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.1,334.63a4.51,4.51,0,0,1-4.08,0c-1.13-.66-1.14-1.71,0-2.36a4.51,4.51,0,0,1,4.08,0A1.24,1.24,0,0,1,406.1,334.63Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "66.3 254.43 66.04 254.27 34 234.46 34.52 233.61 66.31 253.26 80.81 244.56 80.81 223.95 91.81 206.2 91.81 182.76 92.81 182.76 92.81 206.49 81.81 224.24 81.81 245.13 66.3 254.43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.22,353.38a4.51,4.51,0,0,1-4.08,0,1.25,1.25,0,0,1,0-2.36,4.51,4.51,0,0,1,4.08,0C407.34,351.68,407.35,352.74,406.22,353.38Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "103.63 271.9 103.63 280.76 160.85 247.39 160.85 238.53 103.63 271.9"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "103.66 271.9 103.66 280.76 46.26 247.3 46.26 238.47 103.66 271.9"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "46.26 238.47 103.66 271.9 160.85 238.53 103.38 205.06 46.26 238.47"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-3",
    points: "103.63 260.38 103.63 269.74 156.79 238.73 156.79 229.37 103.63 260.38"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "103.65 260.38 103.65 269.74 50.31 238.64 50.31 229.32 103.65 260.38"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "103.63 253.44 103.63 267.46 160.85 234.09 160.85 220.07 103.63 253.44"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "103.66 253.44 103.66 267.46 46.26 234 46.26 220.01 103.66 253.44"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "46.26 220.01 103.66 253.44 160.85 220.07 103.38 186.61 46.26 220.01"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-3",
    points: "103.63 241.99 103.63 251.35 156.79 220.34 156.79 210.98 103.63 241.99"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "103.65 241.99 103.65 251.35 50.31 220.25 50.31 210.93 103.65 241.99"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "103.63 229.9 103.63 249.07 160.85 215.7 160.85 196.53 103.63 229.9"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "103.66 229.9 103.66 249.07 46.26 215.61 46.26 196.47 103.66 229.9"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "46.26 196.47 103.66 229.9 160.85 196.53 103.38 163.06 46.26 196.47"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-3",
    points: "103.63 218.17 103.63 227.53 156.79 196.52 156.79 187.16 103.63 218.17"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "103.65 218.17 103.65 227.53 50.31 196.43 50.31 187.11 103.65 218.17"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "103.63 199.55 103.63 224.91 160.85 191.54 160.85 166.18 103.63 199.55"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "103.66 199.55 103.66 224.91 46.26 191.45 46.26 166.12 103.66 199.55"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "46.26 166.12 103.66 199.55 160.85 166.18 103.38 132.72 46.26 166.12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M435.64,306.47c0,1.3-.92,1.82-2.05,1.17a4.51,4.51,0,0,1-2-3.53c0-1.3.92-1.82,2-1.17A4.52,4.52,0,0,1,435.64,306.47Z",
    transform: "translate(-371.42 -118.42)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M500.31,315.58a4.54,4.54,0,0,1-2.05,3.53c-1.13.65-2,.13-2-1.17a4.49,4.49,0,0,1,2-3.53C499.39,313.76,500.31,314.28,500.31,315.58Z",
    transform: "translate(-371.42 -118.42)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M518.89,351.91a4.49,4.49,0,0,1-2,3.53c-1.13.65-2.05.13-2.05-1.17a4.54,4.54,0,0,1,2.05-3.53C518,350.09,518.89,350.61,518.89,351.91Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "130.89 289.78 109.93 277.21 109.98 255.96 126.35 221.81 126.35 198.34 127.35 198.34 127.35 222.04 127.3 222.14 110.93 256.29 110.93 276.64 131.4 288.92 130.89 289.78"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M512.14,334.83a4.53,4.53,0,0,1-2,3.53c-1.13.65-2.05.13-2.05-1.17a4.51,4.51,0,0,1,2.05-3.53C511.23,333,512.14,333.53,512.14,334.83Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "161.93 289.68 124.93 267.96 124.93 261.78 125.01 261.66 138.18 241.03 138.18 217.59 139.18 217.59 139.18 241.32 139.1 241.44 125.93 262.07 125.93 267.39 161.92 288.51 168.58 284.49 169.09 285.35 161.93 289.68"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "36.43 259.51 36.17 259.35 4.12 239.54 4.65 238.69 36.43 258.34 50.93 249.64 50.93 229.03 61.93 211.28 61.93 187.84 62.93 187.84 62.93 211.57 51.93 229.32 51.93 250.21 36.43 259.51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.35,358.47a4.54,4.54,0,0,1-4.08,0,1.25,1.25,0,0,1,0-2.36,4.54,4.54,0,0,1,4.08,0A1.25,1.25,0,0,1,376.35,358.47Z",
    transform: "translate(-371.42 -118.42)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M449.39,345c0,1.3-.92,1.82-2.05,1.17a4.51,4.51,0,0,1-2-3.53c0-1.3.92-1.82,2-1.17A4.52,4.52,0,0,1,449.39,345Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "43.18 277.93 30.68 271.81 31.13 270.91 43.13 276.79 69.93 260.89 69.93 247.53 75.68 238.78 75.68 226.34 76.68 226.34 76.68 239.07 70.93 247.82 70.93 261.46 70.69 261.6 43.18 277.93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.62,391a4.51,4.51,0,0,1-4.08,0,1.25,1.25,0,0,1,0-2.36,4.51,4.51,0,0,1,4.08,0A1.24,1.24,0,0,1,402.62,391Z",
    transform: "translate(-371.42 -118.42)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M461.64,328.52c0,1.3-.91,1.82-2,1.17a4.51,4.51,0,0,1-2.05-3.53c0-1.3.92-1.82,2.05-1.17A4.53,4.53,0,0,1,461.64,328.52Z",
    transform: "translate(-371.42 -118.42)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M456.39,366.52c0,1.3-.91,1.82-2,1.17a4.51,4.51,0,0,1-2.05-3.53c0-1.3.92-1.82,2.05-1.17A4.53,4.53,0,0,1,456.39,366.52Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "86.64 283.42 86.13 282.57 96.18 276.64 96.18 256.27 87.68 234.01 87.68 210.43 88.68 210.43 88.68 233.92 97.18 256.18 97.18 277.21 86.64 283.42"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.6,402.84a4.48,4.48,0,0,1-4.08,0c-1.13-.65-1.14-1.7,0-2.35a4.48,4.48,0,0,1,4.08,0A1.24,1.24,0,0,1,459.6,402.84Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "48.68 289.36 48.18 288.49 82.93 268.63 82.93 248.18 83.93 248.18 83.93 269.21 83.68 269.36 48.68 289.36"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M421.64,408.77a4.49,4.49,0,0,1-4.07,0c-1.13-.66-1.14-1.71,0-2.36a4.51,4.51,0,0,1,4.08,0C422.76,407.07,422.77,408.12,421.64,408.77Z",
    transform: "translate(-371.42 -118.42)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505.89,410a4.49,4.49,0,0,1-4.07,0c-1.13-.66-1.14-1.71,0-2.36a4.51,4.51,0,0,1,4.08,0C507,408.32,507,409.37,505.89,410Z",
    transform: "translate(-371.42 -118.42)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M555.44,379.27a4.51,4.51,0,0,1-4.08,0c-1.13-.66-1.14-1.71,0-2.36a4.51,4.51,0,0,1,4.08,0C556.55,377.57,556.56,378.62,555.44,379.27Z",
    transform: "translate(-371.42 -118.42)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543.17,403.77a4.49,4.49,0,0,1-4.07,0,1.25,1.25,0,0,1,0-2.36,4.54,4.54,0,0,1,4.08,0A1.25,1.25,0,0,1,543.17,403.77Z",
    transform: "translate(-371.42 -118.42)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M524,300.58a4.54,4.54,0,0,1-2,3.53c-1.13.65-2,.13-2-1.17a4.49,4.49,0,0,1,2-3.53C523.1,298.76,524,299.28,524,300.58Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "162.93 254.76 155.43 250.34 155.43 217.3 150.06 207.05 150.06 183.34 151.06 183.34 151.06 206.8 156.43 217.05 156.43 249.76 162.93 253.59 196.16 233.16 196.68 234.01 162.93 254.76"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M570.76,352.43a4.48,4.48,0,0,1-4.08,0,1.24,1.24,0,0,1,0-2.35,4.51,4.51,0,0,1,4.08,0A1.24,1.24,0,0,1,570.76,352.43Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "181.72 260.36 181.22 259.49 166.22 268.1 145.76 256.22 145.76 235.76 144.76 235.76 144.76 256.8 165.97 269.11 166.47 269.11 181.72 260.36"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "109.06 172.74 108.06 172.74 108.06 166.52 94.93 159.08 94.93 55.7 78.9 31.4 78.91 8.02 79.91 8.02 79.9 31.1 95.93 55.39 95.93 158.5 109.06 165.94 109.06 172.74"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "123.72 161.72 122.72 161.72 122.72 156.7 110.73 149.71 98.08 157.23 98.08 67.37 98.17 67.24 125.57 30.17 126.37 30.77 99.08 67.7 99.08 155.47 110.73 148.55 123.72 156.13 123.72 161.72"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "83.46 166.5 82.46 166.5 82.46 158.6 91.75 153.6 91.75 84.5 83.91 68.45 67.54 62.16 54.79 47.26 55.55 46.61 68.14 61.31 84.64 67.65 92.75 84.27 92.75 154.2 83.46 159.2 83.46 166.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M482,292.15a4.48,4.48,0,0,1-4.08,0,1.24,1.24,0,0,1,0-2.35,4.48,4.48,0,0,1,4.08,0A1.24,1.24,0,0,1,482,292.15Z",
    transform: "translate(-371.42 -118.42)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M496.79,281.62a4.49,4.49,0,0,1-4.07,0c-1.13-.65-1.14-1.7,0-2.35a4.51,4.51,0,0,1,4.08,0C497.91,279.92,497.92,281,496.79,281.62Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "101.15 146.24 101.15 99.58 101.25 99.45 127.61 64.5 127.71 64.45 160.73 48.06 164.11 35.43 165.07 35.69 161.58 48.76 128.26 65.29 102.15 99.91 102.15 144.46 113.23 137.77 113.23 145.3 112.23 145.3 112.23 139.54 101.15 146.24"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M486.11,265a4.51,4.51,0,0,1-4.08,0,1.24,1.24,0,0,1,0-2.35,4.51,4.51,0,0,1,4.08,0A1.25,1.25,0,0,1,486.11,265Z",
    transform: "translate(-371.42 -118.42)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M456.45,286.47a4.48,4.48,0,0,1-4.08,0,1.24,1.24,0,0,1,0-2.35,4.48,4.48,0,0,1,4.08,0A1.24,1.24,0,0,1,456.45,286.47Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "82.87 178.99 81.87 178.99 81.87 174.16 92 168.24 92 161.1 93 161.1 93 168.81 82.87 174.74 82.87 178.99"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M455.86,299a4.51,4.51,0,0,1-4.08,0,1.25,1.25,0,0,1,0-2.36,4.54,4.54,0,0,1,4.08,0A1.25,1.25,0,0,1,455.86,299Z",
    transform: "translate(-371.42 -118.42)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M466,282.74c0,1.3-.92,1.82-2.05,1.17a4.49,4.49,0,0,1-2-3.53c0-1.3.91-1.82,2-1.17A4.54,4.54,0,0,1,466,282.74Z",
    transform: "translate(-371.42 -118.42)"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "125.31 175.1 124.31 175.1 124.31 170.84 108.59 161.81 108.59 154.1 109.59 154.1 109.59 161.23 125.31 170.26 125.31 175.1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M494.16,295.07a4.51,4.51,0,0,0,4.08,0,1.24,1.24,0,0,0,0-2.35,4.51,4.51,0,0,0-4.08,0A1.25,1.25,0,0,0,494.16,295.07Z",
    transform: "translate(-371.42 -118.42)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M478.46,275.74c0,1.3.92,1.82,2.05,1.17a4.54,4.54,0,0,0,2.05-3.53c0-1.3-.92-1.82-2.05-1.17A4.51,4.51,0,0,0,478.46,275.74Z",
    transform: "translate(-371.42 -118.42)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 63.41,
    width: 33.38,
    height: 20.77
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 63.41,
    y: 15.6,
    width: 33.39,
    height: 3.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 63.41,
    y: 1.74,
    width: 33.39,
    height: 3.33
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M456.06,131.37h-8.92l4.5-7.7Zm-7.64-.74h6.37l-3.16-5.49Z",
    transform: "translate(-371.42 -118.42)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M451.64,133.91l-4.5-7.7h8.92Zm-3.22-7,3.21,5.5,3.16-5.5Z",
    transform: "translate(-371.42 -118.42)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 398.45,
    y: 152.31,
    width: 34.27,
    height: 1.63,
    transform: "translate(-373.11 183.16) rotate(-39.81)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 396.37,
    y: 149.8,
    width: 34.27,
    height: 1.63,
    transform: "translate(-371.99 181.24) rotate(-39.81)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 394.28,
    y: 147.3,
    width: 34.27,
    height: 1.63,
    transform: "translate(-370.87 179.32) rotate(-39.81)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 400.54,
    y: 154.81,
    width: 34.27,
    height: 1.63,
    transform: "translate(-374.23 185.08) rotate(-39.81)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 402.63,
    y: 157.32,
    width: 34.27,
    height: 1.63,
    transform: "translate(-375.35 186.99) rotate(-39.81)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 404.72,
    y: 159.82,
    width: 34.27,
    height: 1.63,
    transform: "translate(-376.47 188.91) rotate(-39.81)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 406.8,
    y: 162.32,
    width: 34.27,
    height: 1.63,
    transform: "translate(-377.59 190.82) rotate(-39.81)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 397.41,
    y: 151.06,
    width: 34.27,
    height: 1.63,
    transform: "translate(-372.55 182.2) rotate(-39.81)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 395.33,
    y: 148.55,
    width: 34.27,
    height: 1.63,
    transform: "translate(-371.43 180.28) rotate(-39.81)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 399.5,
    y: 153.56,
    width: 34.27,
    height: 1.63,
    transform: "translate(-373.67 184.12) rotate(-39.81)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 401.58,
    y: 156.06,
    width: 34.27,
    height: 1.63,
    transform: "translate(-374.79 186.03) rotate(-39.81)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 403.67,
    y: 158.57,
    width: 34.27,
    height: 1.63,
    transform: "translate(-375.91 187.95) rotate(-39.81)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 405.76,
    y: 161.07,
    width: 34.27,
    height: 1.63,
    transform: "translate(-377.03 189.87) rotate(-39.81)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 399.44,
    y: 153.26,
    width: 12.81,
    height: 9.87,
    transform: "matrix(0.77, -0.64, 0.64, 0.77, -378.61, 178.09)"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "35.83 34.73 36.18 34.94 35.77 34.96 35.77 34.96 35.77 34.97 35.68 35.36 35.54 34.98 35.54 34.97 35.54 34.97 35.14 35.01 35.45 34.76 35.28 34.39 35.63 34.61 35.63 34.61 35.63 34.61 35.94 34.35 35.82 34.73 35.82 34.73 35.83 34.73"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "37.1 36.27 37.45 36.47 37.05 36.5 37.05 36.49 37.05 36.5 36.95 36.89 36.81 36.51 36.81 36.5 36.81 36.51 36.41 36.54 36.72 36.29 36.56 35.92 36.9 36.14 36.9 36.14 36.9 36.14 37.21 35.88 37.1 36.27 37.1 36.27 37.1 36.27"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "38.38 37.8 38.73 38 38.33 38.03 38.32 38.02 38.32 38.03 38.23 38.42 38.09 38.04 38.09 38.03 38.09 38.03 37.69 38.08 38 37.82 37.84 37.45 38.18 37.67 38.18 37.67 38.18 37.67 38.49 37.41 38.38 37.8 38.38 37.8 38.38 37.8"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "39.66 39.33 40 39.53 39.6 39.56 39.6 39.56 39.6 39.56 39.51 39.95 39.37 39.57 39.37 39.57 39.37 39.57 38.96 39.61 39.27 39.35 39.11 38.98 39.45 39.2 39.45 39.2 39.45 39.2 39.77 38.94 39.65 39.33 39.65 39.33 39.66 39.33"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "34.2 36.09 34.55 36.3 34.15 36.32 34.14 36.32 34.14 36.32 34.05 36.71 33.91 36.33 33.91 36.33 33.91 36.33 33.51 36.37 33.82 36.11 33.66 35.75 34 35.96 34 35.96 34 35.96 34.31 35.7 34.2 36.09 34.19 36.09 34.2 36.09"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "35.48 37.62 35.82 37.83 35.42 37.85 35.42 37.85 35.42 37.85 35.32 38.24 35.19 37.86 35.19 37.86 35.19 37.86 34.78 37.9 35.09 37.64 34.93 37.28 35.27 37.49 35.27 37.5 35.27 37.49 35.58 37.23 35.47 37.62 35.47 37.62 35.48 37.62"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.75 39.15 37.1 39.36 36.7 39.38 36.7 39.38 36.7 39.38 36.6 39.78 36.46 39.4 36.46 39.39 36.46 39.39 36.06 39.43 36.37 39.18 36.21 38.81 36.55 39.03 36.55 39.03 36.55 39.02 36.86 38.77 36.75 39.15 36.75 39.15 36.75 39.15"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "38.03 40.68 38.38 40.89 37.97 40.91 37.97 40.91 37.97 40.92 37.88 41.31 37.74 40.93 37.74 40.92 37.74 40.92 37.34 40.96 37.64 40.71 37.48 40.34 37.82 40.56 37.83 40.56 37.83 40.56 38.14 40.3 38.02 40.69 38.02 40.69 38.03 40.68"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "32.57 37.45 32.92 37.65 32.52 37.68 32.52 37.68 32.52 37.68 32.42 38.07 32.28 37.69 32.28 37.69 32.28 37.69 31.88 37.73 32.19 37.47 32.03 37.11 32.37 37.32 32.37 37.32 32.37 37.32 32.68 37.06 32.57 37.45 32.57 37.45 32.57 37.45"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "33.85 38.98 34.2 39.19 33.79 39.21 33.79 39.21 33.79 39.21 33.7 39.6 33.56 39.22 33.56 39.22 33.56 39.22 33.16 39.26 33.46 39 33.3 38.64 33.64 38.85 33.64 38.85 33.64 38.85 33.96 38.59 33.84 38.98 33.84 38.98 33.85 38.98"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "35.12 40.51 35.47 40.72 35.07 40.74 35.07 40.74 35.07 40.74 34.97 41.13 34.83 40.75 34.83 40.75 34.83 40.75 34.43 40.79 34.74 40.53 34.58 40.17 34.92 40.38 34.92 40.38 34.92 40.38 35.23 40.12 35.12 40.51 35.12 40.51 35.12 40.51"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.4 42.04 36.75 42.25 36.35 42.27 36.34 42.27 36.34 42.27 36.25 42.66 36.11 42.28 36.11 42.28 36.11 42.28 35.71 42.32 36.02 42.06 35.85 41.7 36.2 41.91 36.2 41.92 36.2 41.91 36.51 41.65 36.4 42.04 36.4 42.04 36.4 42.04"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "30.97 38.78 31.32 38.99 30.91 39.01 30.91 39.01 30.91 39.01 30.82 39.41 30.68 39.02 30.68 39.02 30.68 39.02 30.28 39.06 30.59 38.8 30.43 38.44 30.77 38.66 30.77 38.66 30.77 38.66 31.08 38.4 30.97 38.78 30.96 38.78 30.97 38.78"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "32.25 40.31 32.59 40.52 32.19 40.55 32.19 40.54 32.19 40.55 32.09 40.94 31.95 40.56 31.96 40.55 31.95 40.55 31.55 40.59 31.86 40.34 31.7 39.97 32.04 40.19 32.04 40.19 32.04 40.19 32.35 39.93 32.24 40.31 32.24 40.31 32.25 40.31"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "33.52 41.85 33.87 42.05 33.47 42.08 33.47 42.07 33.47 42.08 33.37 42.47 33.23 42.09 33.23 42.08 33.23 42.08 32.83 42.13 33.14 41.87 32.98 41.5 33.32 41.72 33.32 41.72 33.32 41.72 33.63 41.46 33.52 41.84 33.52 41.84 33.52 41.85"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "34.8 43.38 35.15 43.58 34.74 43.61 34.74 43.6 34.74 43.61 34.65 44 34.51 43.62 34.51 43.62 34.51 43.62 34.11 43.66 34.41 43.4 34.25 43.03 34.59 43.25 34.59 43.25 34.59 43.25 34.91 42.99 34.8 43.38 34.79 43.38 34.8 43.38"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "29.37 40.12 29.72 40.33 29.31 40.35 29.31 40.35 29.31 40.35 29.22 40.74 29.08 40.36 29.08 40.36 29.08 40.36 28.68 40.4 28.98 40.14 28.82 39.77 29.16 39.99 29.16 39.99 29.16 39.99 29.48 39.73 29.36 40.12 29.36 40.12 29.37 40.12"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "30.64 41.65 30.99 41.86 30.59 41.88 30.59 41.88 30.59 41.88 30.49 42.27 30.35 41.89 30.35 41.89 30.35 41.89 29.95 41.93 30.26 41.67 30.1 41.31 30.44 41.52 30.44 41.52 30.44 41.52 30.75 41.26 30.64 41.65 30.64 41.65 30.64 41.65"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "31.92 43.18 32.27 43.39 31.86 43.41 31.86 43.41 31.86 43.41 31.77 43.8 31.63 43.42 31.63 43.42 31.63 43.42 31.23 43.46 31.54 43.2 31.38 42.84 31.72 43.05 31.72 43.05 31.72 43.05 32.03 42.79 31.91 43.18 31.91 43.18 31.92 43.18"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "33.2 44.71 33.54 44.92 33.14 44.94 33.14 44.94 33.14 44.94 33.05 45.33 32.91 44.95 32.91 44.95 32.91 44.95 32.5 44.99 32.81 44.73 32.65 44.37 32.99 44.58 32.99 44.59 32.99 44.58 33.3 44.32 33.19 44.71 33.19 44.71 33.2 44.71"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "37.25 34.84 37.6 35.05 37.2 35.07 37.2 35.07 37.2 35.07 37.1 35.46 36.96 35.08 36.97 35.08 36.96 35.08 36.56 35.12 36.87 34.86 36.71 34.5 37.05 34.71 37.05 34.71 37.05 34.71 37.36 34.45 37.25 34.84 37.25 34.84 37.25 34.84"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "38.53 36.37 38.88 36.58 38.48 36.6 38.48 36.6 38.48 36.6 38.38 36.99 38.24 36.62 38.24 36.61 38.24 36.61 37.84 36.65 38.15 36.39 37.98 36.03 38.33 36.24 38.33 36.24 38.33 36.24 38.64 35.98 38.53 36.37 38.53 36.37 38.53 36.37"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "39.81 37.9 40.16 38.11 39.75 38.13 39.75 38.13 39.75 38.13 39.66 38.53 39.52 38.15 39.52 38.14 39.52 38.14 39.12 38.18 39.43 37.93 39.26 37.56 39.6 37.78 39.6 37.78 39.61 37.78 39.92 37.52 39.8 37.9 39.8 37.91 39.81 37.9"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "41.09 39.44 41.43 39.65 41.03 39.67 41.03 39.67 41.03 39.67 40.94 40.06 40.8 39.68 40.8 39.67 40.8 39.68 40.4 39.72 40.7 39.46 40.54 39.09 40.88 39.31 40.88 39.31 40.88 39.31 41.2 39.05 41.08 39.44 41.08 39.44 41.09 39.44"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "35.98 33.32 36.33 33.52 35.93 33.55 35.93 33.55 35.93 33.55 35.83 33.94 35.69 33.56 35.69 33.55 35.69 33.55 35.29 33.6 35.6 33.34 35.44 32.97 35.78 33.19 35.78 33.19 35.78 33.19 36.09 32.93 35.98 33.31 35.98 33.32 35.98 33.32"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "35.66 36.17 36.01 36.37 35.61 36.4 35.61 36.4 35.61 36.4 35.51 36.79 35.37 36.41 35.37 36.4 35.37 36.41 34.97 36.45 35.28 36.19 35.12 35.82 35.46 36.04 35.46 36.04 35.46 36.04 35.77 35.78 35.66 36.17 35.66 36.17 35.66 36.17"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.94 37.7 37.29 37.91 36.88 37.93 36.88 37.93 36.88 37.93 36.79 38.32 36.65 37.94 36.65 37.94 36.65 37.94 36.25 37.98 36.56 37.72 36.39 37.35 36.73 37.57 36.73 37.57 36.74 37.57 37.05 37.31 36.94 37.7 36.93 37.7 36.94 37.7"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "38.22 39.23 38.56 39.44 38.16 39.46 38.16 39.46 38.16 39.46 38.07 39.85 37.92 39.47 37.93 39.47 37.92 39.47 37.52 39.51 37.83 39.25 37.67 38.89 38.01 39.1 38.01 39.1 38.01 39.1 38.32 38.84 38.21 39.23 38.21 39.23 38.22 39.23"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "39.49 40.77 39.84 40.97 39.44 40.99 39.44 40.99 39.44 40.99 39.34 41.39 39.2 41.01 39.2 41 39.2 41 38.8 41.05 39.11 40.79 38.95 40.42 39.29 40.64 39.29 40.64 39.29 40.64 39.6 40.38 39.49 40.77 39.49 40.77 39.49 40.77"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "34.39 34.64 34.74 34.85 34.34 34.87 34.34 34.87 34.34 34.87 34.24 35.26 34.1 34.88 34.1 34.88 34.1 34.88 33.7 34.92 34.01 34.66 33.85 34.3 34.19 34.52 34.19 34.52 34.19 34.52 34.5 34.26 34.39 34.64 34.39 34.64 34.39 34.64"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "34.01 37.55 34.35 37.75 33.95 37.78 33.95 37.78 33.95 37.78 33.86 38.17 33.72 37.79 33.72 37.78 33.72 37.78 33.31 37.83 33.62 37.57 33.46 37.2 33.8 37.42 33.8 37.42 33.8 37.42 34.12 37.16 34 37.55 34 37.55 34.01 37.55"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "35.28 39.08 35.63 39.28 35.23 39.31 35.23 39.31 35.23 39.31 35.13 39.7 34.99 39.32 34.99 39.32 34.99 39.32 34.59 39.36 34.9 39.1 34.74 38.73 35.08 38.95 35.08 38.95 35.08 38.95 35.39 38.69 35.28 39.08 35.28 39.08 35.28 39.08"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.56 40.61 36.91 40.82 36.51 40.84 36.5 40.84 36.51 40.84 36.41 41.23 36.27 40.85 36.27 40.85 36.27 40.85 35.87 40.89 36.18 40.63 36.02 40.27 36.36 40.48 36.36 40.48 36.36 40.48 36.67 40.22 36.56 40.61 36.55 40.61 36.56 40.61"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "37.84 42.15 38.19 42.35 37.78 42.38 37.78 42.37 37.78 42.38 37.69 42.77 37.55 42.39 37.55 42.38 37.55 42.38 37.15 42.42 37.46 42.17 37.3 41.8 37.64 42.02 37.64 42.02 37.64 42.02 37.95 41.76 37.84 42.14 37.83 42.15 37.84 42.15"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "32.74 36.02 33.09 36.23 32.68 36.25 32.68 36.25 32.68 36.25 32.59 36.64 32.45 36.27 32.45 36.26 32.44 36.26 32.05 36.3 32.35 36.05 32.19 35.68 32.53 35.9 32.53 35.9 32.53 35.89 32.84 35.63 32.73 36.02 32.73 36.02 32.74 36.02"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "32.39 38.9 32.73 39.1 32.33 39.13 32.33 39.13 32.33 39.13 32.24 39.52 32.1 39.14 32.1 39.13 32.09 39.13 31.7 39.17 32 38.92 31.84 38.55 32.18 38.77 32.19 38.77 32.18 38.77 32.5 38.51 32.38 38.9 32.38 38.9 32.39 38.9"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "33.66 40.43 34.01 40.63 33.61 40.66 33.61 40.66 33.61 40.66 33.51 41.05 33.37 40.67 33.37 40.67 33.37 40.67 32.97 40.71 33.28 40.45 33.12 40.09 33.46 40.3 33.46 40.3 33.46 40.3 33.77 40.04 33.66 40.43 33.66 40.43 33.66 40.43"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "34.94 41.96 35.29 42.17 34.89 42.19 34.88 42.19 34.89 42.19 34.79 42.58 34.65 42.2 34.65 42.2 34.65 42.2 34.25 42.24 34.56 41.98 34.4 41.62 34.74 41.83 34.74 41.83 34.74 41.83 35.05 41.57 34.94 41.96 34.94 41.96 34.94 41.96"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "36.22 43.49 36.57 43.7 36.17 43.72 36.16 43.72 36.16 43.73 36.07 44.12 35.93 43.74 35.93 43.73 35.93 43.73 35.53 43.77 35.84 43.52 35.67 43.15 36.02 43.37 36.02 43.37 36.02 43.37 36.33 43.11 36.22 43.49 36.21 43.49 36.22 43.49"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "31.12 37.37 31.46 37.58 31.06 37.6 31.06 37.6 31.06 37.6 30.97 37.99 30.83 37.62 30.83 37.61 30.82 37.61 30.43 37.65 30.73 37.4 30.57 37.03 30.91 37.24 30.91 37.25 30.91 37.24 31.23 36.98 31.11 37.37 31.11 37.37 31.12 37.37"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "30.8 40.22 31.15 40.42 30.75 40.45 30.75 40.45 30.75 40.45 30.65 40.84 30.51 40.46 30.51 40.45 30.51 40.46 30.11 40.5 30.42 40.24 30.26 39.87 30.6 40.09 30.6 40.09 30.6 40.09 30.91 39.83 30.8 40.22 30.8 40.22 30.8 40.22"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "32.08 41.75 32.43 41.96 32.02 41.98 32.02 41.98 32.02 41.98 31.93 42.37 31.79 41.99 31.79 41.99 31.79 41.99 31.39 42.03 31.7 41.77 31.53 41.41 31.88 41.62 31.88 41.62 31.88 41.62 32.19 41.36 32.07 41.75 32.07 41.75 32.08 41.75"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "33.36 43.28 33.7 43.49 33.3 43.51 33.3 43.51 33.3 43.51 33.21 43.91 33.06 43.52 33.07 43.52 33.07 43.52 32.66 43.56 32.97 43.31 32.81 42.94 33.15 43.15 33.15 43.16 33.15 43.16 33.46 42.89 33.35 43.28 33.35 43.28 33.36 43.28"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "34.63 44.81 34.98 45.02 34.58 45.05 34.58 45.04 34.58 45.05 34.48 45.44 34.34 45.06 34.34 45.05 34.34 45.05 33.94 45.1 34.25 44.84 34.09 44.47 34.43 44.69 34.43 44.69 34.43 44.69 34.74 44.43 34.63 44.81 34.63 44.82 34.63 44.81"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "29.53 38.69 29.88 38.9 29.48 38.92 29.48 38.92 29.48 38.92 29.38 39.31 29.24 38.94 29.24 38.93 29.24 38.93 28.84 38.97 29.15 38.72 28.99 38.35 29.33 38.57 29.33 38.57 29.33 38.56 29.64 38.31 29.53 38.69 29.53 38.69 29.53 38.69"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "29.19 41.56 29.54 41.77 29.14 41.79 29.14 41.79 29.14 41.79 29.04 42.18 28.9 41.8 28.9 41.8 28.9 41.8 28.5 41.84 28.81 41.58 28.64 41.22 28.99 41.43 28.99 41.44 28.99 41.43 29.3 41.17 29.19 41.56 29.18 41.56 29.19 41.56"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "30.47 43.09 30.82 43.3 30.41 43.32 30.41 43.32 30.41 43.32 30.32 43.72 30.18 43.34 30.18 43.33 30.18 43.33 29.77 43.37 30.08 43.12 29.92 42.75 30.26 42.97 30.26 42.97 30.26 42.97 30.58 42.7 30.46 43.09 30.46 43.09 30.47 43.09"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "31.74 44.63 32.09 44.83 31.69 44.85 31.69 44.85 31.69 44.86 31.59 45.25 31.45 44.87 31.45 44.86 31.45 44.86 31.05 44.91 31.36 44.65 31.2 44.28 31.54 44.5 31.54 44.5 31.54 44.5 31.85 44.24 31.74 44.63 31.74 44.63 31.74 44.63"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "33.02 46.16 33.37 46.37 32.97 46.39 32.97 46.39 32.97 46.39 32.87 46.78 32.73 46.4 32.73 46.4 32.73 46.4 32.33 46.44 32.64 46.18 32.48 45.82 32.82 46.03 32.82 46.03 32.82 46.03 33.13 45.77 33.02 46.16 33.02 46.16 33.02 46.16"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "27.92 40.04 28.27 40.24 27.87 40.27 27.86 40.27 27.86 40.27 27.77 40.66 27.63 40.28 27.63 40.27 27.63 40.27 27.23 40.32 27.54 40.06 27.37 39.69 27.72 39.91 27.72 39.91 27.72 39.91 28.03 39.65 27.92 40.04 27.91 40.04 27.92 40.04"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 157.51,
    y: 11.43,
    width: 33.23,
    height: 20.86
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 157.51,
    y: 21.51,
    width: 33.23,
    height: 10.78
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 157.51,
    y: 18.29,
    width: 33.25,
    height: 7.02
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 110.22,
    y: 10.12,
    width: 33.23,
    height: 20.86
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.22,
    y: 20.65,
    width: 33.23,
    height: 10.33
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 110.22,
    y: 16.98,
    width: 33.25,
    height: 7.02
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 110.22,
    y: 10.12,
    width: 8.24,
    height: 20.83
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLang);
export default __webpack_public_path__ + "static/media/multiLang.6e1ee40e12a66ed43bbdd3a99380f246.svg";
export { ForwardRef as ReactComponent };